import RefreshIcon from 'components/Icons/RefreshIcon';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import {
  projectEdit,
  projectFluxControlRoute,
  projetosPath,
} from 'library/Routes';
import { EtapaProjeto } from 'models/projeto';
import { useContext, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Container } from '../../components/Container';
import Conteudo from './Conteudo/conteudo';
import styles from './FluxoProjetos.scss';

const rootClassName = styles.rootClassName;
export default function FluxoProjetos() {
  const { state, carregar, dispatch } = useContext(ProjetosContext);
  const { id, stepSlugName } = useParams<{
    id: string;
    stepSlugName: string;
  }>();
  const history = useHistory();

  useEffect(() => {
    const currentEtapa = Object.values(EtapaProjeto).find(
      (e) => e === stepSlugName
    );
    if (id) {
      carregar(id, currentEtapa ?? EtapaProjeto.infosIniciais)
        .then((projeto) => {
          if (projeto?.flgNovoTemplate === false) {
            // TEMPLATE ANTIGO
            history.replace(
              projectEdit.getURLWithParams(projeto.id, stepSlugName)
            );
          } else if (
            !stepSlugName ||
            !Object.values<string>(EtapaProjeto).includes(stepSlugName)
          ) {
            // NOVO TEMPLATE
            history.replace(
              projectFluxControlRoute.getURLWithParams({
                id: projeto ? projeto.id : undefined,
                step: EtapaProjeto.revisao,
              })
            );
          }
        })
        .catch(() => {
          history.replace(projetosPath);
        });
    } else {
      if (
        !stepSlugName ||
        !Object.values(EtapaProjeto).includes(stepSlugName as EtapaProjeto)
      ) {
        history.replace(
          projectFluxControlRoute.getURLWithParams({
            step: EtapaProjeto.infosIniciais,
          })
        );
      }
      dispatch({
        type: 'setContratoLoading',
        payload: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container
      className={rootClassName + '-container container-fluid'}
      noPadding
    >
      <div className={`${rootClassName}-inside-container`}>
        {state.loading ? (
          <div className={`${rootClassName}-loader`}>
            <RefreshIcon className={rootClassName + '-loading-icon'} />
            Carregando informações...
          </div>
        ) : (
          <Conteudo />
        )}
      </div>
    </Container>
  );
}
